module.exports = __webpack_public_path__ + "static/media/countries.ab583aa1.geojson";